export default "__VITE_ASSET__RfAtVCuY__"